import styled from 'styled-components';

export const PropertyIconButton = ({
  isActive,
  iconClassName,
  onClick,
  style,
  fontSize = 18,
}: {
  isActive?: boolean;
  iconClassName: string;
  onClick?: () => void;
  style?: React.CSSProperties;
  fontSize?: number;
}) => {
  return (
    <IconButton $isActive={isActive} onClick={onClick} style={style}>
      <i className={iconClassName} style={{ fontSize: fontSize + 'px', lineHeight: fontSize + 'px' }} />
    </IconButton>
  );
};

const IconButton = styled.div<{ $isActive?: boolean }>`
  box-sizing: border-box;
  width: 25px;
  height: 25px;
  border-radius: var(--radius-2);
  background-color: var(--neutral-2);

  font-size: 17px;
  color: var(--main-2);
  line-height: 1;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    ${({ $isActive }) =>
      !$isActive &&
      `
      background-color: var(--neutral-3);
      color: var(--main-1);
    `}
  }

  ${({ $isActive }) => $isActive && `color: var(--primary-1); border-color: var(--primary-1); cursor: default;`}

  ${({ $isActive }) =>
    $isActive && `color: var(--primary-1); background-color: var(--neutral-1); border-color: transparent;`}

  transition: background-color var(--transition-2), color var(--transition-2), border-color var(--transition-2);
`;
